/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-03 17:55:25
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-21 13:28:39
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/legal/index.ts
 */
import { post, remove, get } from 'src/tools/server';

const getLegalPage = (uuid, params) => {
  return get<any[]>(`/portal/salesChannel/legalPage/${uuid}`, params || {});
};

const getLegalPages = (uuid) => {
  return get<any[]>(`/portal/salesChannel/${uuid}/legalPages`, {});
};

const duplicateLegalPages = (uuid, body) => {
  return post<any[]>(
    `/portal/salesChannel/legalPage/${uuid}/duplicate`,
    body,
    {},
  );
};

const duplicateTCPages = (uuid, body) => {
  return post<any[]>(
    `/portal/salesChannel/termsCondition/${uuid}/duplicate`,
    body,
    {},
  );
};

const deleteLegalPage = (uuid) => {
  return remove<any>(`/portal/salesChannel/legalPage/${uuid}`, {});
};

const postLegalPage = (body, params): Promise<any> => {
  return post<any>(`/portal/salesChannel/legalPage`, body, { ...params });
};

const postCheckLegalName = (body, params): Promise<any> => {
  return post<any>(`/portal/salesChannel/legalPage/checkName`, body, {
    ...params,
  });
};

const postCheckTCName = (body, params): Promise<any> => {
  return post<any>(`/portal/salesChannel/termsCondition/checkName`, body, {
    ...params,
  });
};

const getTC = (uuid, params) => {
  return get<any[]>(
    `/portal/salesChannel/termsCondition/${uuid}`,
    params || {},
  );
};

const getTCs = (uuid, params?) => {
  return get<any[]>(`/portal/salesChannel/${uuid}/termsConditions`, {
    ...params,
  });
};

const deleteTC = (uuid) => {
  return remove<any>(`/portal/salesChannel/termsCondition/${uuid}`, {});
};

const postTC = (body, params): Promise<any> => {
  return post<any>(`/portal/salesChannel/termsCondition`, body, {
    ...(params || {}),
  });
};

export {
  deleteTC,
  postTC,
  getLegalPage,
  postLegalPage,
  deleteLegalPage,
  getTC,
  getLegalPages,
  getTCs,
  postCheckLegalName,
  postCheckTCName,
  duplicateLegalPages,
  duplicateTCPages,
};
